"use client";

import { c as _c } from "react/compiler-runtime";
import { resolveProductWrappers } from "@/lib/product/resolveProductWrappers";
import type { TypeProductBuilder } from "@/types/contentful/generated";
import ProductBuilderClient from "./ProductBuilderClient";
type Props = TypeProductBuilder<undefined, string>["fields"];
export default function ProductBuilderDraft(props) {
  const $ = _c(6);
  let t0;
  if ($[0] !== props.productWrappers) {
    t0 = resolveProductWrappers(props.productWrappers);
    $[0] = props.productWrappers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resolvedWrappers = t0;
  if (resolvedWrappers.length === 0) {
    return null;
  }
  let t1;
  if ($[2] !== props.parentProductDescription || $[3] !== props.parentProductTitle || $[4] !== resolvedWrappers) {
    t1 = <ProductBuilderClient resolvedWrappers={resolvedWrappers} parentProductTitle={props.parentProductTitle} parentProductDescription={props.parentProductDescription} />;
    $[2] = props.parentProductDescription;
    $[3] = props.parentProductTitle;
    $[4] = resolvedWrappers;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}